module.exports = __webpack_public_path__ + "static/media/IMG_6648.dcede8fb.JPG";